import React, { Component } from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import { connect } from 'react-redux'

import {
  Card,
  CardBody,
} from 'reactstrap'
import FacebookButton from './FacebookButton'
import { CardEditForm } from '../'
import { CardContent, Loading, CardFooter } from '../../components'
import { appIsFacebookShare } from '../../constants/lockedAppsAndTokens'

import { ONE_CARD_REQUEST } from '../../constants/action-types'


const StyledCard = styled(Card)`
  margin: 0 auto;
  @media screen and (max-width: 768px){
    max-width: 100%;
    margin: 0 0.75rem;
  }
  >:first-child{
    border-radius: 4px 4px 0 0;
    + .card-body{
      padding-top: 1.25rem
    }
  }
  >:last-child{
    border-radius: 0 0 4px 4px;
  }
`
const StyledCardBody = styled(CardBody)`
text-align: center;
`
class GetCardContent extends Component {
  constructor(props) {
    super()
    this.oneCardRequest = props.oneCardRequest.bind(this)
  }
  render() {
    const {
      fetching,
      currentCard,
      //  error,
      appId,
      edit,
    } = this.props
    switch (appId) {
      case 'gris':
        currentCard.title = 'Ce qui vous inspire le plus ce soir?';
        break
      case 'jaune':
        currentCard.title = 'Une organisation super innovante: ça ressemble à quoi au quotidien?';
        break
      case 'rose':
        currentCard.title = 'Où avez-vous vos meilleures idées ?';
        break
      case 'turquoise':
        currentCard.title = 'Vous considérez-vous comme une personne créative?';
        break
      case 'cmtl':
        currentCard.title = 'Comment je peux intéresser les filles et les femmes aux technologies?'
        break
      default:
        break
    }
    return (
      <div className="App">
        {fetching.ONE_CARD ? (<Loading />) : ((
            (currentCard.tokenId || currentCard.cardId) && !edit &&
            <div>
              <StyledCard>
                <CardContent currentCard={currentCard} tokenId={currentCard.tokenId} appId={appId} />
                {appIsFacebookShare(appId) &&
                  <StyledCardBody>
                    <FacebookButton
                      text="Partager"
                      tokenId={currentCard.tokenId}
                      cardId={currentCard.cardId}
                      appId={appId}
                    />
                  </StyledCardBody>
                }
                <CardFooter appId={appId} tokenId={currentCard.tokenId} />
              </StyledCard>
            </div>
        ))}
        {fetching.ONE_CARD ? (<div />) : ((
            (currentCard.tokenId || currentCard.cardId) && edit &&
            <div>
              <StyledCard>
                <CardEditForm currentCard={currentCard} tokenId={currentCard.tokenId} appId={appId} />
              </StyledCard>
            </div>
          ))}

      </div>
    )
  }
}

const mapStateToProps = state => ({
  fetching: state.root.fetching,
  error: state.root.error,
  currentCard: state.root.currentCard,
  allCards: state.root.allCards,
})

const mapDispatchToProps = dispatch => ({
  oneCardRequest: (appInfo, tokenId) => dispatch({ type: ONE_CARD_REQUEST, tokenId }),
})

GetCardContent.defaultProps = {
  currentCard: { parts: [{ type: 'base' }] },
  fetching: false
}

GetCardContent.propTypes = {
  currentCard: PropTypes.object,
  fetching: PropTypes.any,
}
export default connect(mapStateToProps, mapDispatchToProps)(GetCardContent)



// WEBPACK FOOTER //
// ./src/containers/GetCardContent/index.js